import { Injectable } from '@angular/core';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class AgendaService {

  baseURL = environment.baseUrl + 'agenda';

  constructor(private http: HttpClient) {
  }

  getAllAgenda(eventId: any): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/event/`+eventId);
  }
  saveAgenda(data: any): Observable<any> {
    return this.http.post<any>(`${this.baseURL}`, data);
  }

  updateAgenda(data: any): Observable<any> {
    return this.http.put<any>(`${this.baseURL}`, data);
  }
  updateStatus(agendaId:any,status:boolean,eventId:any): Observable<any> {
    return this.http.patch<any>(`${this.baseURL}/`+agendaId+'/status/'+status+'/event/'+eventId,{});
  }
  deleteAgenda(agendaId:any,eventId:any):Observable<any> {
    return this.http.delete<any>(`${this.baseURL}/`+agendaId+'/event/'+eventId,{});
  }
}
